
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/simple-present-explanation';
const mainimage = '/Images/simppres1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "simplepresent" },
];

const SimplePresent = () => (
  <GrammarPageLayout
    level="A1"
    title="Simple Present"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Simple Present Exercises"
    seoDescription="Learn to use the simple present tense for habits, routines, and general truths. A1 level exercises with explanations."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default SimplePresent;

